import React from 'react';

interface RightAlignedFormatterProps {
  value: any;
}

const RightAlignedFormatter: React.FC<RightAlignedFormatterProps> = ({ value }) => {
  return <div style={{ flex: 1, textAlign: 'right', marginRight: '10px' }}>{value}</div>;
};

export default RightAlignedFormatter;
